export enum Sounds {
    BACKGROUND,
    CAT_MEOW,
    CAT_PURR,
}

export const SoundLocation: { [key: number]: string } = {
    [Sounds.BACKGROUND]: process.env.PUBLIC_URL + "/sounds/jungle.ogg",
    [Sounds.CAT_MEOW]: process.env.PUBLIC_URL + "/sounds/cat-meow.ogg",
    [Sounds.CAT_PURR]: process.env.PUBLIC_URL + "/sounds/cat-purr.ogg",
};
